import React, { ReactNode, useMemo } from 'react'
import { Icon } from 'semantic-ui-react'
import usePlayerActions from '../../hooks/usePlayerActions'
import { useSelector } from '../../../../hooks/useSelector'
import PromiseMenuItem from '../../../../components/PromiseMenuItem'
import formatCost from '../../../../utils/formatCost'
import { round } from 'lodash'
import { calcQuest } from './calculateQuestBonus'
import { Card, Cards, Popup, Stack, Typography } from '@prometheus/components'
import PromiseCard from '@/components/PromiseCard'

interface LOCRateUpgradesPopupProps {
  children: ReactNode
}

export default ({ children }: LOCRateUpgradesPopupProps) => {
  const _bond_rate_upgrades = useSelector(s => s.game.options?.bond_rate_upgrades) || []
  const bonds = useSelector(s => s.game.sheet?.bonds)
  const level = bonds?.rate_level || 0
  const base_bond_rate_change = (useSelector(s => s.game.metadata?.prime_rate) || 0)
  const bond_rate_global_factor = (useSelector(s => s.game.metadata?.global_bond_rate_addition) || 0)
  const quest_bond_bonus = useSelector(s => s.game.sheet?.quests.rewards.bond_rate_bonus)

  const bond_rate_additions = base_bond_rate_change * .5 * 100 + bond_rate_global_factor * 100 + calcQuest(quest_bond_bonus || []) * 100

  const bond_rate_upgrades = useMemo(() => {
    const BRU = [..._bond_rate_upgrades]
    for (let i = 0; i < 100; i++) {
      if (_bond_rate_upgrades.length < 100) {
        const x = i + _bond_rate_upgrades.length
        const previous = BRU[BRU.length - 1].cost.resources
        BRU.push({
          rate: x + 12,
          cost: { resources: { Au: (previous?.Au || 0) * 2, Dia: (previous?.Dia || 0) * 2, U: (previous?.U || 0) * 2 } },
        })
      }
    }
    return BRU.slice(Math.max(level, 0), level + 6)
  }, [_bond_rate_upgrades, level])

  const {
    onUpgrade,
  } = usePlayerActions()

  return (
    <Popup hoverable position="bottom right" trigger={children}>
      <Card padding="sm" style={{ width: 'min(400px, calc(100vw - 20px))' }}>
        <Stack>
          <Typography variant="h4">Bond Rate Upgrades <Typography variant="h4" component="span" color="secondary">Level {level + 1}</Typography></Typography>
          <Cards style={{ maxHeight: '512px', overflowY: 'auto' }}>
            {bond_rate_upgrades.map(({ cost, rate }, i) => {
              const disabled = i !== 1
              const isNextUpgrade = i === 1
              const isUpgraded = i < 1
              let color: string | undefined = undefined;
              if (isUpgraded) color = 'var(--prometheus-secondary)'
              else if (disabled) color = 'var(--prometheus-gray-500)'
              let onClick
              if (isNextUpgrade) {
                onClick = () => onUpgrade('bond_rate')
              }
              return (
                <PromiseCard padding="sm" key={rate} ignoreGameLogic interactive disabled={disabled} onClick={onClick}>
                  <Stack direction="row" style={{ justifyContent: 'space-between' }}>
                    <Typography style={{ color }}>Level {i + level + 1} | Rate: { round(rate + bond_rate_additions, 2) }%</Typography>
                    {isNextUpgrade && (<Icon name="angle double up" style={{ color }} size="large" />)}
                    {isUpgraded && (<Icon name="check square" style={{ color: 'var(--prometheus-secondary' }} size="large" />)}
                  </Stack>
                  <Typography style={{ color }}>{formatCost(cost)}</Typography>
                </PromiseCard>
              )
            })}
          </Cards>
        </Stack>
      </Card>
    </Popup>
  )
}
